"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../Icons");

var _IconContainer = _interopRequireDefault(require("../IconContainer"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorMapContainer = (0, _styledComponents.default)(_IconContainer.default).withConfig({
  displayName: "ColorMapContainer",
  componentId: "sc-1dooevk-0"
})(["flex:0 0 auto;margin-right:0.5rem;svg{color:", ";}"], function (p) {
  return p.type ? (0, _helpers.statusToColor)(p.type) : (0, _helpers.color)('black60');
});

var Icon = function Icon(_ref) {
  var type = _ref.type;
  return _react.default.createElement(ColorMapContainer, {
    type: type
  }, {
    critical: _react.default.createElement(_Icons.WarningBoldIcon, null),
    warning: _react.default.createElement(_Icons.WarningIcon, null),
    ok: _react.default.createElement(_Icons.AcceptedIcon, null),
    info: _react.default.createElement(_Icons.InfoIcon, null)
  }[type] || _react.default.createElement(_Icons.InfoIcon, null));
};

exports.Icon = Icon;